import { extend } from 'flarum/common/extend';
import Navigation from 'flarum/common/components/Navigation';
import Banner from '../components/Banner'

export default () => {
    extend(Navigation.prototype, 'view', function(vnode) {
        vnode.children.push(<Banner className="Banner-header" />);
    });
}
